import { FetchError } from "./api.fetch.client";

export const is40x = (error: unknown) => {
  return (
    error instanceof FetchError &&
    error.payload.status >= 400 &&
    error.payload.status < 500
  );
};